import { useState } from "react";
import { Fade } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import { MdExpandMore } from "react-icons/md";

function CheckComponent({ hasData, idx, cb }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = () => {
    setIsExpanded(!isExpanded);
    cb(idx);
  };

  return (
    <Fade in appear>
      <span
        onClick={handleClick}
        key={idx}
        className="d-flex align-items-center justify-content-center"
        style={{
          padding: hasData ? "3px 5px" : "1.5px 0 1.5px 5px",
          color: hasData ? "#58BC7A" : "#D08E62",
          background: hasData ? "#F1FFF4" : "#FFFFF0",
          border: hasData ? "0.5px solid #CAF6D6" : "0.5px solid #F6E05E",
          fontSize: "13px",
          borderRadius: "5px",
          fontWeight: "600",
          cursor: hasData ? "" : "pointer",
        }}
      >
        {hasData ? (
          <>
            Data Checked
            <FaCheckCircle
              style={{
                marginLeft: "5px",
              }}
            />
          </>
        ) : (
          <>
            Invalid Values
            <MdExpandMore
              style={{
                fontSize: "24px",
                transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
              }}
            />
          </>
        )}
      </span>
    </Fade>
  );
}

export default CheckComponent;
